import { render, staticRenderFns } from "./ClientPolicy.vue?vue&type=template&id=0e2f192f&"
import script from "./ClientPolicy.vue?vue&type=script&lang=js&"
export * from "./ClientPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports